module.exports = __webpack_public_path__ + "static/Canela-Thin-94dcc129efb6719d686e2fe8887eb872.woff2";